export default __webpack_public_path__ + "static/breadcrumbs-size-do-dark-7ceb8bdcbfc7f0051867e59da5a6245fc30bdfb38779554fa5d41d89999b3bcd.png";